import React from 'react'
import styled from 'styled-components'

const Grid = ({ children }) => {
  return <Wrapper>{children}</Wrapper>
}

const Wrapper = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: auto;
  grid-gap: var(--size-4);

  @media (min-width: 480px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
`

const Item = styled.li``

export default Grid
